module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    class: _vm.colClass
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    class: _vm.fieldClass
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-acab2740"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormGroup.vue
// module id = 169
// module chunks = 1